const BASKET = "basket/";

export const SELECT_EXERCISE = BASKET + "selectExercise";
export const CLEAR_SELECT_EXERCISE = BASKET + "clearSelectExercise";
export const ADD_TICKET_WITH_EXERCISE_TO_BAKSKET = BASKET + "addTicketWithExerciseToBasket";
export const REMOVE_TICKET_WITH_EXERCISE_FROM_BASKET = BASKET + "removeTicketWithExerciseFromBasket";
export const CLEAR_BASKET = BASKET + "clearBasket";
export const SELECT_EXERCISE_BY_SEAT = BASKET + "selectExerciseBySeat";
export const ADD_TICKET_WITH_SEAT_TO_BASKET = BASKET + "addTicketWithSeatToBasket";
export const REMOVE_TICKET_WITH_SEAT_FROM_BASKET = BASKET + "removeTicketWithSeatFromBasket";
export const SET_ACTIVE_STEP = BASKET + "setActiveStep";
